import {ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener, Input, OnChanges} from '@angular/core';
import {TypedSimpleChanges} from '../../../../../../../../common/typed-on-changes';
import {Widget} from '../../../../../../../../components/layout/widget/widget';
import {WidgetLinkingGroupService} from '../../../../../../../../components/widget-linking-group';
import {WidgetLinkingGroupId} from '../../../../../../../../enums/widget-linking-group';
import {WHeaderTitlePartGroupSharedData} from './w-header-title-part-group-shared';

@Component({
    selector:        'w-header-title-part-group-shared',
    templateUrl:     './w-header-title-part-group-shared.component.html',
    styleUrls:       ['./w-header-title-part-group-shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WHeaderTitlePartGroupSharedComponent implements OnChanges {

    @Input()
    public data: WHeaderTitlePartGroupSharedData<any>;

    @Input()
    public widget: Widget;

    constructor(
        private widgetLinkingGroupService: WidgetLinkingGroupService,
        private changeDetectorRef: ChangeDetectorRef
    ) {}

    @HostListener('click')
    public handleClick(): void {
        const widget = this.widget;
        const {sharedSettingName, sharedSettingValue} = this.data;

        const isWidgetActive = widget.cell.activeWidget === widget;
        const linkingGroupId = widget.linkingGroupId || WidgetLinkingGroupId.ALL;

        if (isWidgetActive && sharedSettingName && sharedSettingValue) {
            this.widgetLinkingGroupService.setLinkingGroupSettings(
                linkingGroupId,
                widget.tabId,
                {
                    [sharedSettingName]: sharedSettingValue
                } as any
            );
        }
    }

    public ngOnChanges(changes: TypedSimpleChanges<WHeaderTitlePartGroupSharedComponent>): void {
        if (changes.data && !changes.data.isFirstChange()) {
            this.changeDetectorRef.markForCheck();
        }
    }

}
